<template>
  <div class="journal-inner" v-loading="loading">
    <div class="tool">
      <div
        class="download col-btn"
        v-if="hasPermission('Manage journals_Edit')"
        @click="createPdf('download', 1)"
        :class="{ 'col-btn1': pdfGenerating || pdfFailed }"
      >
        <div v-if="pdfGenerating" class="col-tit col-tit1">PDF is generating</div>
        <div v-else-if="pdfFailed" class="col-tit col-tit1">PDF generation failed</div>
        <div v-else class="col-tit">Download</div>
        <img v-if="pdfGenerating || pdfFailed" src="@/assets/images/icons/download_dis.png" />
        <img v-else src="@/assets/images/icons/download_black_24dp.svg" />
      </div>
      <!--     <div class="download col-btn" v-if="hasPermission('Manage journals_Edit')" @click="createPdf('download', 3)"><div class="col-tit">1.5倍</div><img src="@/assets/images/icons/download_black_24dp.svg" /></div>
      <div class="download col-btn" v-if="hasPermission('Manage journals_Edit')" @click="zoom()"><div class="col-tit">变大</div><img src="@/assets/images/icons/download_black_24dp.svg" /></div> -->
      <div
        class="print col-btn"
        v-if="hasPermission('Manage journals_Edit')"
        @click="createPdf('print')"
        :class="{ 'col-btn1': pdfGenerating || pdfFailed }"
      >
        <div v-if="pdfGenerating" class="col-tit col-tit1">PDF is generating</div>
        <div v-else-if="pdfFailed" class="col-tit col-tit1">PDF generation failed</div>
        <div v-else class="col-tit">Print</div>
        <img v-if="pdfGenerating || pdfFailed" src="@/assets/images/icons/print-dis.png" />
        <img v-else src="@/assets/images/icons/print-24px.svg" />
      </div>
      <div class="download col-btn" v-if="canRetryPdf" @click="regeneratePdf">
        <div class="col-tit">{{ status === 'PENDING' ? 'Approve' : 'Retry' }}</div>
        <img src="@/assets/images/icons/refresh_black_24dp.svg" />
      </div>
      <div
        class="download col-btn"
        v-if="hasPermission('Manage journals_Edit') && pdfPollingStale"
        @click="refreshPdfState"
      >
        <div class="col-tit">Refresh</div>
        <img src="@/assets/images/icons/refresh_black_24dp.svg" />
      </div>
    </div>
    <div v-if="isPdfNewsletter" class="view-carousel-inner pdf-newsletter-preview" :class="type">
      <el-carousel
        @change="carouselChange"
        :autoplay="false"
        arrow="always"
        :loop="false"
        :height="height + 'px'"
        indicator-position="none"
      >
        <el-carousel-item v-for="(image, index) in pdfImageList" :key="index">
          <div class="pdf-view-page">
            <img :src="normalizePdfImagePath(image)" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="indicator">
        <span class="s">Page</span> {{ viewCarouselIndex }} <span class="t">/</span>
        {{ pdfImageList.length }}
      </div>
    </div>
    <div v-else class="view-carousel-inner" :class="type">
      <el-carousel
        @change="carouselChange"
        :autoplay="false"
        arrow="always"
        :loop="false"
        :height="height + 'px'"
        indicator-position="none"
      >
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <div class="journal-page" ref="page">
            <components
              v-if="item.no"
              :data="item.data"
              :index="index"
              :is="item.no + '-s'"
            ></components>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="indicator">
        <span class="s">Page</span> {{ viewCarouselIndex }} <span class="t">/</span>
        {{ list.length }}
      </div>
    </div>
    <el-dialog
      :visible.sync="journalApproveSw"
      :title="'Approve ' + (type === 'portfolio' ? 'portfolio' : 'newsletter') + '?'"
      width="500px"
    >
      <div>
        Once approved, the {{ type === 'portfolio' ? 'portfolio' : 'newsletter' }} will be shared
        and viewed by parents after its PDF is ready.
      </div>
      <span slot="footer">
        <gg-cancel-button @click="journalApproveSw = false">Cancel</gg-cancel-button>
        <gg-submit-button :disabled="regenerating" @click="approvePdf">Approve</gg-submit-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import printJS from 'print-js'
import { Ajax } from '@/common'
import { loadDraft, saveDraft } from '@/common/nav-state'
import { mapState } from 'vuex'
// import domtoimage from "dom-to-image";
import domtoimage from 'dom-to-image-more'
import { htmlDecode, hasPermission } from './../utils/utils.js'
import { approvalErrorMessage } from './../utils/pdf-list-state'

// import { hasPermission } from './../utils/utils.js'
import newsletterAS from './../modules/model/newsletterAS'
import newsletterOS from './../modules/model/newsletterOS'
import newsletterBS from './../modules/model/newsletterBS'
import newsletterCS from './../modules/model/newsletterCS'
import newsletterDS from './../modules/model/newsletterDS'
import newsletterES from './../modules/model/newsletterES'
import newsletterFS from './../modules/model/newsletterFS'
import newsletterGS from './../modules/model/newsletterGS'
import newsletterHS from './../modules/model/newsletterHS'
import newsletterIS from './../modules/model/newsletterIS'
import newsletterJS from './../modules/model/newsletterJS'
import newsletterKS from './../modules/model/newsletterKS'
import newsletterLS from './../modules/model/newsletterLS'
import newsletterMS from './../modules/model/newsletterMS'
import newsletterNS from './../modules/model/newsletterNS'
import portfolioAS from './../modules/model/portfolioAS'
import portfolioBS from './../modules/model/portfolioBS'
import portfolioCS from './../modules/model/portfolioCS'
import portfolioDS from './../modules/model/portfolioDS'
import portfolioES from './../modules/model/portfolioES'
import { jsPDF } from 'jspdf'

export default {
  components: {
    newsletterAS,
    newsletterBS,
    newsletterCS,
    newsletterDS,
    newsletterES,
    newsletterFS,
    newsletterGS,
    newsletterHS,
    newsletterIS,
    newsletterJS,
    newsletterKS,
    newsletterLS,
    newsletterMS,
    newsletterNS,
    portfolioAS,
    portfolioBS,
    portfolioCS,
    portfolioDS,
    newsletterOS,
    portfolioES
  },
  data() {
    return {
      pdfurl: '',
      loading: false,
      type: '',
      list: [],
      title: '',
      status: '',
      filePath: '',
      isPdfNewsletter: false,
      pdfImageList: [],
      viewCarouselIndex: 1,
      height: '',
      journalId: '',
      draftToken: '',
      journalDataRouteId: null,
      pdfFailCount: 0,
      pdfGenerationToken: '',
      regenerating: false,
      journalApproveSw: false,
      pdfPollTimer: null,
      pdfPollRemaining: 0,
      pdfFetchSeq: 0,
      pdfFetchInFlight: false,
      pdfApprovedMark: false,
      destroyed: false
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    }),
    pdfFailed() {
      // 失败终态只看"无路径 + 达上限"，覆盖 PENDING（新语义）与存量 POSTED
      return (
        !(this.filePath || '').trim() && !this.pdfApprovedMark && Number(this.pdfFailCount) >= 5
      )
    },
    canRetryPdf() {
      return (
        this.pdfFailed &&
        (this.status === 'PENDING'
          ? this.hasPermission('Share journals_Full')
          : this.status === 'POSTED' && this.hasPermission('Manage journals_Edit'))
      )
    },
    pdfGenerating() {
      // POSTED 无路径（存量语义）或 PENDING 已批准生成中（token/失败计数标记）
      return (
        !(this.filePath || '').trim() &&
        !this.pdfFailed &&
        (this.status === 'POSTED' ||
          (this.status === 'PENDING' && (this.pdfApprovedMark || Number(this.pdfFailCount) > 0)))
      )
    },
    // 自动轮询预算已耗尽但仍未拿到结果：提供手动 Refresh，不再假装自动刷新
    pdfPollingStale() {
      return this.pdfGenerating && !this.pdfPollTimer && !!this.journalId
    }
  },
  watch: {
    // 通道切换（同组件复用 A→B）：draft/id 任一变化按新通道重载；
    // 相同通道 key 不重复加载，id 通道另有请求身份丢弃过期响应
    '$route.query.draft'() {
      this._onRouteChannelChange()
    },
    '$route.query.id'() {
      this._onRouteChannelChange()
    }
  },
  created() {
    this.type = this.$route.query.type || ''
    this._loadChannel()
  },
  mounted() {
    window.onresize = () => {
      this.getHeight()
    }
    this.getHeight()
    this._maybeStartPolling()
  },
  beforeDestroy() {
    this.destroyed = true
    this.stopPdfPolling()
  },
  methods: {
    htmlDecode,

    hasPermission,
    parseStoredList(value) {
      if (!value) return []
      try {
        const list = JSON.parse(value)
        return Array.isArray(list) ? list : []
      } catch (error) {
        console.log(error)
        return []
      }
    },

    isPdfJournal(item) {
      return Boolean(
        item &&
        (item.isPdf === true ||
          item.pdfNewsletter === true ||
          item.isPdfNewsletter === true ||
          (Array.isArray(item.pdfImages) && item.pdfImages.length) ||
          (Array.isArray(item.pdfThumbnailImages) && item.pdfThumbnailImages.length) ||
          (Array.isArray(item.imagePaths) && item.imagePaths.length))
      )
    },

    getPdfImages(item) {
      if (!item) return []
      const images = item.pdfImages || item.pdfThumbnailImages || item.imagePaths || []
      return Array.isArray(images) ? images.filter(Boolean) : []
    },

    normalizePdfImagePath(path) {
      if (!path) return ''
      if (/^https?:\/\//i.test(path)) return path
      return `${process.env.VUE_APP_fileBasePath}${path}`
    },

    normalizeFilePath(path) {
      if (!path || path === 'null') return ''
      if (/^https?:\/\//i.test(path)) return path
      return `${process.env.VUE_APP_fileBasePath}${path}`
    },

    // 双通道读取序（Plan 4 契约）：?draft=<token> → ?id=<journalId> → 缺失守卫拒绝
    _loadChannel() {
      this._loadedChannelKey = this._channelKey()
      this._resetRecordState()
      const draftToken = this.$route.query.draft
      if (draftToken) {
        this._loadDraftChannel(String(draftToken))
        return
      }
      if (this.$route.query.id) {
        this.getData()
        return
      }
      this._missingJournal()
    },

    _channelKey() {
      return String(this.$route.query.draft || '') + '|' + String(this.$route.query.id || '')
    },

    _onRouteChannelChange() {
      if (this._channelKey() === this._loadedChannelKey) {
        return
      }
      this.stopPdfPolling()
      this._loadChannel()
      this._maybeStartPolling()
    },

    // 切换通道先清记录态：旧记录的 journalId/pdfGenerating 不得带进新通道（loading 窗口拒绝写操作）；
    // regenerating 是通道内请求的重入门闩，随通道切换释放，过期响应一律丢弃不回写
    _resetRecordState() {
      this.regenerating = false
      // #1297 审批弹窗属于旧记录：换通道不得带着旧弹窗对新记录发起 Approve
      this.journalApproveSw = false
      this.list = []
      this.title = ''
      this.status = ''
      this.filePath = ''
      this.isPdfNewsletter = false
      this.pdfImageList = []
      this.journalId = ''
      this._loadedJournalId = ''
      this.draftToken = ''
      this.journalDataRouteId = null
      this.pdfFailCount = 0
      this.pdfApprovedMark = false
      this.pdfGenerationToken = ''
    },

    _loadDraftChannel(draftToken) {
      // draft 通道读 token 内快照（Task 1 写入方按字符串编码的 9 字段），本地变更回写见 _syncDraftPdfState
      const payload = loadDraft('journalEditor', draftToken)
      if (!payload || typeof payload !== 'object') {
        this._missingJournal()
        return
      }
      this.loading = false
      this.draftToken = draftToken
      this.isPdfNewsletter = payload.isPdf === 'true'
      this.pdfImageList = this.parseStoredList(payload.pdfImages)
      this.list = this.isPdfNewsletter ? [] : this.parseStoredList(payload.pageData)
      this.title = payload.title
      this.status = payload.status
      this.filePath = payload.filePath
      this.journalId = payload.journalId || ''
      // 写身份只认通道加载时交接的行主键：可变 journalId 可能被过期响应覆写，绝不进写载荷
      this._loadedJournalId = this.journalId
      const storedFailCount = payload.pdfFailCount
      this.pdfFailCount = storedFailCount == null ? 0 : Number(storedFailCount)
      this.pdfGenerationToken = payload.pdfGenerationToken || ''
      this.pdfApprovedMark = !!payload.pdfGenerationToken
      if (this.filePath == 'null') {
        this.filePath = ''
      }
    },

    // 通道建立失败（缺参/坏 token）：提示并回列表，不渲染半套数据（同 otherPosted _missingAnnouncement 口径）
    _missingJournal() {
      this.$message.error('Missing journal')
      this.$router.replace('/journal')
    },

    // 写操作的行主键（R18 审计：GET/regenerate/PUT 全程 journal.id 主键单命名空间）：
    // 只信已归属当前通道身份的行主键（id 通道=fetched DTO、draft 通道=payload 交接），
    // 且只认通道加载时落地的 _loadedJournalId——可变 journalId 可能被过期响应覆写，绝不进写载荷；
    // 响应未到/缺参返回 null，绝不回落路由键（Ruling R18）
    _verifiedRowId() {
      const draftToken = this.$route.query.draft
      if (draftToken) {
        return this.draftToken === String(draftToken) ? this._loadedJournalId || null : null
      }
      const routeId = this.$route.query.id
      if (!routeId || this.journalDataRouteId !== String(routeId)) {
        return null
      }
      return this._loadedJournalId || null
    },

    // draft 通道的 PDF 状态是 token 内快照：本地变更（Retry 重置/轮询落地）覆写同一 token，
    // 刷新后不倒退回旧值（审计 §1 表：4 个 PDF 键随通道收纳）；id 通道服务端持久化，无需回写
    _syncDraftPdfState() {
      if (!this.draftToken) {
        return
      }
      const payload = loadDraft('journalEditor', this.draftToken)
      if (!payload || typeof payload !== 'object') {
        return
      }
      saveDraft(
        'journalEditor',
        {
          ...payload,
          status: this.status || '',
          filePath: this.filePath || '',
          pdfFailCount: String(this.pdfFailCount),
          pdfGenerationToken: this.pdfGenerationToken
        },
        this.draftToken
      )
    },

    _maybeStartPolling() {
      // 生成中的记录轮询状态，生成完成后自动解锁 Download/Print
      if (this.pdfGenerating && this.journalId) {
        this.startPdfPolling()
      }
    },

    getData() {
      this.loading = true
      // 请求身份：通道切换后旧 GET 的响应不得覆盖新记录（A→B 复用）；
      // reqChannel 另围栏通道维度：?id=A → ?id=A&draft=B 时 id 未变但通道已换，同 id 的旧响应也必须丢弃
      const reqId = String(this.$route.query.id)
      const reqChannel = this._channelKey()
      let data = {
        id: this.$route.query.id
      }
      Ajax.get('journal/' + this.$route.query.id, data).then((res) => {
        if (
          this.destroyed ||
          reqId !== String(this.$route.query.id) ||
          reqChannel !== this._channelKey()
        ) {
          return
        }
        this.loading = false
        if (res.code === '0000') {
          let journalData = res.data
          this.isPdfNewsletter = this.isPdfJournal(journalData)
          this.pdfImageList = this.getPdfImages(journalData)
          this.list = this.isPdfNewsletter ? [] : this.parseStoredList(res.data.content)
          this.title = journalData.title
          this.status = journalData.status
          this.filePath = journalData.filePath
          this.journalId = journalData.id
          // 写身份（_verifiedRowId）只认本次通道加载落地的行主键
          this._loadedJournalId = journalData.id
          this.pdfFailCount = journalData.pdfFailCount == null ? 0 : journalData.pdfFailCount
          this.pdfGenerationToken = journalData.pdfGenerationToken || ''
          this.pdfApprovedMark = !!journalData.pdfGenerationToken
          // 记录该 DTO 归属的路由身份：写操作行主键只在与当前路由身份一致时可信（Ruling R18）
          this.journalDataRouteId = reqId
          // mounted 时异步数据尚未就绪，这里才是 id 路径启动轮询的正确时机
          this._maybeStartPolling()
        }
      })
    },

    regeneratePdf() {
      // regenerate 按 journal.id 主键匹配（R18）：只用已核实的行主键，loading 窗口拒绝；
      // 入口可用性沿用 #1297 canRetryPdf（失败达上限 + 权限）判定
      const rowId = this._verifiedRowId()
      if (!rowId || this.regenerating || !this.canRetryPdf) {
        return
      }
      if (this.status === 'PENDING') {
        this.journalApproveSw = true
        return
      }
      this.requestPdfGeneration(false)
    },

    approvePdf() {
      if (this.status !== 'PENDING' || !this.canRetryPdf || this.regenerating) return
      this.requestPdfGeneration(true)
    },

    requestPdfGeneration(approve) {
      // 写载荷行主键只认 _verifiedRowId（R18）：loading 窗口/缺参拒绝，可变 journalId 不进写载荷
      const rowId = this._verifiedRowId()
      if (!rowId || this.destroyed) return
      this.regenerating = true
      this.journalApproveSw = false
      const requestId = rowId
      // 通道围栏：换通道后本响应（成功/失败）一律丢弃，不碰新通道的 pdf 状态与 regenerating 门闩
      const reqChannel = this._channelKey()
      const action = approve ? '/process?approve=true&staffId=' : '/pdf/regenerate?staffId='
      Ajax.put('/journal/' + requestId + action + (this.user && this.user.userId))
        .then((res) => {
          if (this.destroyed || reqChannel !== this._channelKey()) {
            return
          }
          this.regenerating = false
          if (res && res.code === '0000') {
            this.pdfFailCount = 0
            // 重置后即进入"生成中"，保持红标推导一致（draft 通道刷新不丢标记）
            this.pdfGenerationToken = 'pending'
            this.pdfApprovedMark = true
            // 仅当仍是同一记录时回写，避免离开后旧回调污染新记录；draft 通道覆写同 token 快照
            if (this.journalId === requestId) {
              this._syncDraftPdfState()
            }
            this.startPdfPolling()
          } else {
            // 失败不再静默：否则用户点了 Retry 看不到任何反馈和轮询
            if (this.$message) {
              this.$message.error(
                approvalErrorMessage(
                  res,
                  approve
                    ? 'Approval request failed, please refresh and try again'
                    : 'PDF regeneration request failed, please try again'
                )
              )
            }
          }
        })
        .catch((error) => {
          if (this.destroyed || reqChannel !== this._channelKey()) {
            return
          }
          this.regenerating = false
          if (this.$message) {
            this.$message.error(
              approvalErrorMessage(
                error,
                approve
                  ? 'Approval request failed, please refresh and try again'
                  : 'PDF regeneration request failed, please try again'
              )
            )
          }
        })
    },

    startPdfPolling() {
      if (this.destroyed) {
        return
      }
      this.stopPdfPolling()
      // 立即首查一次，避免点击后 10s 内 Network 看不到任何请求的空窗；
      // 之后有界轮询：10s × 12 次全部拉取，覆盖后端单轮重试；到期后 UI 显示
      // Refresh 手动重查，后台定时任务仍会继续自动重试
      this.fetchPdfState()
      this.pdfPollRemaining = 12
      this.pdfPollTimer = setInterval(() => {
        // 串行轮询：上一请求未返回（Ajax timeout 60s > 10s 间隔）时不叠加新请求；
        // 但本轮预算照常消耗，保证 120s 墙钟窗口到期后停表并露出 Refresh，
        // 不会因慢请求把窗口拉长到数分钟
        if (!this.pdfFetchInFlight) {
          this.fetchPdfState()
        }
        this.pdfPollRemaining -= 1
        if (this.pdfPollRemaining <= 0) {
          this.stopPdfPolling()
        }
      }, 10000)
    },

    stopPdfPolling() {
      this.pdfPollRemaining = 0
      if (this.pdfPollTimer) {
        clearInterval(this.pdfPollTimer)
        this.pdfPollTimer = null
      }
    },

    refreshPdfState() {
      // startPdfPolling 已含立即首查，无需重复 fetch
      this.startPdfPolling()
    },

    fetchPdfState() {
      if (!this.journalId || this.destroyed) {
        return
      }
      // 请求序号（epoch）：仅最新一次请求的响应允许落地；
      // 乱序/过期响应（含 Retry 前发出的旧 GET）不得覆盖新状态
      const seq = (this.pdfFetchSeq += 1)
      const requestId = this.journalId
      // 通道围栏：换通道后旧轮询响应不落地（in-flight 标记仍照常释放，避免串行轮询卡死）
      const reqChannel = this._channelKey()
      this.pdfFetchInFlight = true
      Ajax.get('journal/' + this.journalId, { id: this.journalId })
        .then((res) => {
          if (seq === this.pdfFetchSeq) {
            this.pdfFetchInFlight = false
          }
          if (
            this.destroyed ||
            seq !== this.pdfFetchSeq ||
            this.journalId !== requestId ||
            reqChannel !== this._channelKey()
          ) {
            return
          }
          if (res.code === '0000') {
            this.status = res.data.status
            this.filePath = res.data.filePath
            this.pdfFailCount = res.data.pdfFailCount == null ? 0 : res.data.pdfFailCount
            this.pdfGenerationToken = res.data.pdfGenerationToken || ''
            this.pdfApprovedMark = !!res.data.pdfGenerationToken
            // draft 通道把落地状态覆写进同一 token 的快照（审计 §1 flag-2）；id 通道有服务端，无需回写
            this._syncDraftPdfState()
            // 拿到路径（完成）或记录撤回（DRAFT）才停；PENDING 生成中/重试间隙
            // （含 regenerate 预占 reset 窗口）继续轮询，不再因"非 POSTED"提前停表
            if ((res.data.filePath || '').trim() || this.status === 'DRAFT' || this.pdfFailed) {
              this.stopPdfPolling()
            }
          }
        })
        .catch(() => {
          if (seq === this.pdfFetchSeq) {
            this.pdfFetchInFlight = false
          }
        })
    },

    HTMLEncode(html) {
      var temp = document.createElement('div')
      temp.textContent != null ? (temp.textContent = html) : (temp.innerText = html)
      var output = temp.innerHTML
      temp = null
      return output
    },

    carouselChange(e) {
      this.viewCarouselIndex = e + 1
    },

    getHeight() {
      const h = document.documentElement.clientHeight
      this.height = h
    },
    zoom() {
      let pages = this.$refs.page
      for (let idx = 0; idx < pages.length; idx++) {
        pages[idx].style.transform = 'scale(2)'
      }
    },

    async createPdf(type, x) {
      if (this.isPdfNewsletter) {
        if (!this.filePath) {
          return
        }

        this.loading = true
        const fileUrl = this.normalizeFilePath(this.filePath)
        if (type === 'download') {
          window.open(fileUrl, '_blank')
        } else if (type === 'print') {
          printJS({
            printable: fileUrl,
            type: 'pdf'
          })
        }
        this.loading = false
        return
      }

      if (this.status === 'POSTED' && !this.$route.query.rebuild) {
        if (!this.filePath) {
          return
        }
        this.loading = true
        if (type === 'download') {
          window.open(`${process.env.VUE_APP_fileBasePath}${this.filePath}`, '_blank')
        } else if (type === 'print') {
          printJS({
            printable: `${process.env.VUE_APP_fileBasePath}${this.filePath}`,
            type: 'pdf'
          })
        }
        this.loading = false
      } else {
        this.loading = true
        let pages = this.$refs.page

        let toImages = []
        let pdf
        let scale = 3
        for (let idx = 0; idx < pages.length; idx++) {
          // if (
          //   /Safari/.test(navigator.userAgent) &&
          //   !/Chrome/.test(navigator.userAgent)
          // ) {
          //   time = time + 16000;
          //   console.log(222);
          // }
          // setTimeout(() => {
          console.log(idx)

          // let width = pages[idx].getBoundingClientRect().width * scale;
          // let height = pages[idx].getBoundingClientRect().height * scale;
          // toImages.push(domtoimage.toJpeg(pages[idx]))
          let imageInfo = await domtoimage.toJpeg(pages[idx], {
            httpTimeout: 600000,
            quality: 0.95,
            width: pages[idx].getBoundingClientRect().width * scale,
            height: pages[idx].getBoundingClientRect().height * scale,
            style: {
              margin: 0,
              transform: 'scale(' + scale + ')',
              // transform: 'scale(1)',
              transformOrigin: 'top left',
              width: pages[idx].getBoundingClientRect().width * scale,
              height: pages[idx].getBoundingClientRect().height * scale
            }
          })
          toImages.push(imageInfo)
          // }, time);
        }
        console.log('ok----', toImages)
        // setTimeout(() => {
        Promise.allSettled(toImages).then((arr) => {
          console.log(arr)
          for (let idx = 0; idx < arr.length; idx++) {
            let width = pages[idx].getBoundingClientRect().width * scale
            let height = pages[idx].getBoundingClientRect().height * scale
            console.log(width)
            console.log(height)
            if (pdf == null) {
              pdf = new jsPDF({
                orientation: width > height ? 'l' : 'p',
                unit: 'mm',
                format: width > height ? [297, 210] : [210, 297]
              })
            }
            pdf.setPage(idx + 1)
            let img = arr[idx].value
            pdf.addImage(
              img,
              'JPEG',
              5,
              5,
              width > height ? 297 - 10 : 210 - 10,
              width > height ? 210 - 10 : 297 - 10
            )
            if (idx + 1 < pages.length) {
              pdf.addPage({
                orientation: width > height ? 'l' : 'p',
                unit: 'mm',
                format: [width, height]
              })
            }
          }
          if (type === 'download') {
            pdf.save(this.title + '.pdf')
          } else if (type === 'print') {
            this.pdfurl = pdf.output('bloburl')
            printJS({
              printable: this.pdfurl,
              type: 'pdf'
            })
          }
          this.loading = false
        })
        // }, time);
      }

      // domtoimage.toJpeg(pages[idx], options).then(
      //       function (pageData) {
      //         // let canvas = await html1canvas(pages[idx], {
      //         //       backgroundColor: "transparent",
      //         //       allowTaint: true,
      //         //       useCORS: true,
      //         //       scale: x
      //         //   });
      //         //
      //         //   let pageData = canvas.toDataURL('image/jpeg', 0.0)
      //         let width = pages[idx].clientWidth * 2
      //         let height = pages[idx].clientHeight * 2
      //         console.log(width)
      //         console.log(height)
      //         if (pdf == null) {
      //           pdf = new jsPDF({
      //             orientation: width > height ? "l" : "p",
      //             unit: "pt",
      //             format: [width, height]
      //           })
      //         }
      //         pdf.setPage(idx + 0)
      //         pdf.addImage(pageData, 'JPEG', -1, 0, width, height)
      //         if (idx + 0 < pages.length) {
      //           pdf.addPage({
      //             orientation: width > height ? "l" : "p",
      //             unit: "pt",
      //             format: [width, height]
      //           })
      //         }
      //     })
      //
      //   if (type === 'download') {
      //     pdf.save(this.title + ".pdf")
      //   } else if (type === 'print') {
      //     this.pdfurl = pdf.output('bloburl')
      //     printJS({
      //       printable: this.pdfurl,
      //       type: 'pdf'
      //     })
      //   }
      //   this.loading = false
    },

    // var buffer = pdf.output("datauristring")
    // // 将base64格式的字符串转换为file文件
    // var myfile = this.dataURLtoFile(buffer, moment().valueOf() + 'files.pdf')

    // var formData = new FormData()
    // formData.append("file", myfile)
    // formData.append("multipartFile", myfile)
    // this.uploadFile(formData)

    uploadFile(formData) {
      if (formData) {
        Ajax.post('/media/public/file/uploadExt', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
          .then((res) => {
            // if (res.code === "0000") {
            //   this.cover = `${process.env.VUE_APP_fileBasePath}${res.data.filePath}`
            // }
            // if (res.code === "9999") {
            //   this.handleSnack("Maximum upload size exceeded")
            // }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      //转换成file对象
      return new File([u8arr], filename, { type: mime })

      //转换成成blob对象
      // return new Blob([u8arr],{type:mime});
    }
  }
}
</script>
<style lang="less" scoped>
.view-carousel-inner {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: #f3f5f7;

  .indicator {
    position: absolute;
    left: 50%;
    bottom: 20px;
    margin-left: -54px;
    width: 108px;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    background: #c2c4c6;
    color: #fff;
    font-size: 14px;
    font-family: Roboto;
    text-align: center;

    .s {
      margin-right: 5px;
    }

    .t {
      margin: 0 5px;
    }
  }

  &.newsletter {
    .journal-page {
      //margin: -333px 0 0 -235px !important;
      width: 470px !important;
      height: 666px !important;
      margin-top: calc(50vh - 330px);
      margin-left: calc(50vw - 235px);
    }
  }
  &.portfolio {
    .journal-page {
      //margin: -235px 0 0 -330px !important;
      width: 660px !important;
      height: 470px !important;
      margin-top: calc(50vh - 235px);
      margin-left: calc(50vw - 330px);
    }
  }
  .journal-page {
    margin-top: 0;
    padding: 0;
    //margin-left: calc(50vw - 330px);
    //margin-top:calc(52vh - 235px);
    //margin:50% !important;
    //width: 470px;
    //height: 666px;
    background: #fff;
  }

  &.pdf-newsletter-preview {
    .pdf-view-page {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 76px 88px 76px;

      img {
        display: block;
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        box-shadow: 0 1px 4px rgba(60, 64, 67, 0.2);
        background: #fff;
      }
    }
  }
}

.tool {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: #fff;
  text-align: right;

  // Retry/Refresh 与 Download/Print 用同类型 24x24 <img> 图标（含新增的
  // refresh_black_24dp.svg），替换元素基线规则天然一致，无需额外对齐样式
  .col-btn {
    position: relative;
    display: inline-block;
    margin-right: 20px;
    vertical-align: middle;
    cursor: pointer;

    &.print {
      .col-tit {
        margin-left: -19px;
        width: 38px;
      }
      .col-tit1 {
        margin-left: -80px;
        width: 110px;
      }
    }

    .col-tit {
      display: none;
      position: absolute;
      left: 50%;
      bottom: -10px;
      margin-left: -32px;
      width: 64px;
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      font-size: 12px;
      text-align: center;
      color: #fff;
      background: #606367;
    }
    .col-tit1 {
      margin-left: -60px;
      width: 110px;
    }

    &:hover {
      .col-tit {
        display: block;
      }
    }
  }
}
</style>
